"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Model = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const uuid = __importStar(require("uuid"));
const ModelRegistry_1 = __importDefault(require("../ModelRegistry"));
const dateTimeRegExp = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/;
/* eslint-disable @typescript-eslint/no-unused-vars */
class Model {
    constructor(o) {
        this.id = uuid.v4();
    }
    get __typename() {
        return '';
    }
    set __typename(v) { }
    init(o) {
        Object.keys(o || {}).forEach(key => {
            if (key !== '__typename')
                this[key] = processItem(o[key]);
        });
    }
}
exports.Model = Model;
exports.default = Model;
function processItem(item) {
    // eslint-disable-next-line eqeqeq
    if (item == null) {
        // null or undefined
        return null;
    }
    if (item.__typename) {
        const ModelFromRegistry = Object.values(ModelRegistry_1.default).find(m => new m().__typename === item.__typename);
        if (ModelFromRegistry) {
            return new ModelFromRegistry(item);
        }
    }
    if (dateTimeRegExp.test(item)) {
        return (0, moment_timezone_1.default)(item);
    }
    if (item instanceof Array) {
        return item.map(child => processItem(child));
    }
    return item;
}
